import React from 'react';
import RichFieldGroup from 'common/components/RichFieldGroup/RichFieldGroup';
import { RICHFIELDS_KEYS } from '../../richfieldsConfig/richfieldsConfig';

const MerchantPreview = ({ config }) => {
  return (
    <RichFieldGroup
      groupId={RICHFIELDS_KEYS.SALON}
      style={config[RICHFIELDS_KEYS.SALON]}
    ></RichFieldGroup>
  );
};

export default MerchantPreview;
